import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=b545161a&scoped=true&lang=pug&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"
import style0 from "./folder.vue?vue&type=style&index=0&id=b545161a&lang=scss&scoped=true&"
import style1 from "./folder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b545161a",
  null
  
)

export default component.exports